/**
 * Extracts order ID from the current URL
 * URL format: https://shopify.com/{shopId}/account/orders/{orderId}
 * @returns Order ID string or null if not found
 */
export const getOrderIdFromUrl = (): string | null => {
  try {
    // In Shopify extensions, we might need to use different methods
    // Try window.location first (if available)
    if (typeof window !== 'undefined' && window.location) {
      const pathname = window.location.pathname;
      const match = pathname.match(/\/orders\/(\d+)/);
      if (match && match[1]) {
        return match[1];
      }
    }
    
    // Fallback: try to get from document location
    if (typeof document !== 'undefined' && document.location) {
      const pathname = document.location.pathname;
      const match = pathname.match(/\/orders\/(\d+)/);
      if (match && match[1]) {
        return match[1];
      }
    }
    
    return null;
  } catch (error) {
    console.error('[getOrderIdFromUrl] Error extracting order ID from URL:', error);
    return null;
  }
};

/**
 * Formats order ID for GraphQL query
 * Converts numeric ID to Shopify GID format: gid://shopify/Order/{id}
 */
export const formatOrderIdForGraphQL = (orderId: string | null): string | null => {
  if (!orderId) return null;
  
  // If already in GID format, return as is
  if (orderId.startsWith('gid://shopify/Order/')) {
    return orderId;
  }
  
  // Convert numeric ID to GID format
  return `gid://shopify/Order/${orderId}`;
};

